import { Injectable } from '@angular/core';
import { MessagesService } from "@core/_services/messages.service";

@Injectable()
export class RequestsService {
    constructor(protected _messageService: MessagesService
    ) { }

}
